module.exports = __webpack_public_path__ + "static/media/pdi-image-10.35c45861.svg";